const BaseUrl = {
  API_URL: "https://api.airduct.itechnolabs.tech/",
};

export default BaseUrl;
